export default {
    ready: 'Abgeschlossene Anträge',
    valid: 'Gültige Karten',
}
